import React from "react"

const NetworkDocumentsContext = React.createContext({})

const { Provider, Consumer } = NetworkDocumentsContext

export { Provider, Consumer, NetworkDocumentsContext }
